import { render, staticRenderFns } from "./AiFeture.vue?vue&type=template&id=3048fa5e&scoped=true"
import script from "./AiFeture.vue?vue&type=script&lang=js"
export * from "./AiFeture.vue?vue&type=script&lang=js"
import style0 from "./AiFeture.vue?vue&type=style&index=0&id=3048fa5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3048fa5e",
  null
  
)

export default component.exports